import React from 'react';
import clsx from 'clsx';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const Item = ({ data = {} }) => {
  // Destructuring fields
  const { heading, icon, image, text, variation, width, textAlignment, withoutBackground } = data;
  // Conditional rendering
  const shouldRenderHeading = !!heading?.value;
  const shouldRenderIcon = !!icon?.value?.src;
  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderText = !!text?.value;
  const widthVariation = width?.fields?.DropdownValue?.value; // Each card can take 3 or 4 columns
  const styleVariation = variation?.fields?.DropdownValue?.value; // Each card can have different styles
  const alignmentVariation = textAlignment?.fields?.DropdownValue?.value; // Each card can be aligned differently
  const shouldRenderWithoutBackground = !!withoutBackground?.value; // Background can be removed

  return (
    // Based on the BE selection we will apply different css classes and adjust the styles accordingly
    <div
      className={clsx(
        'infographic-item',
        shouldRenderWithoutBackground && 'no-bg',
        widthVariation === '4' ? 'col-md-4' : 'col-md-3',
        styleVariation,
        alignmentVariation
      )}
    >
      {shouldRenderImage && <Image field={image} className="infographic-image" />}
      {shouldRenderIcon && (
        <Image
          field={icon}
          className={clsx('infographic-icon', shouldRenderImage && 'with-image')}
        />
      )}
      {shouldRenderHeading && (
        <div
          className={clsx(
            'infographic-heading',
            (shouldRenderImage || shouldRenderIcon) && 'with-margin'
          )}
        >
          <Text field={heading} />
        </div>
      )}
      {shouldRenderText && <RichText field={text} className="infographic-text" />}
    </div>
  );
};

export default Item;
